import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b952b2ac&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b952b2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b952b2ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b952b2ac')) {
      api.createRecord('b952b2ac', component.options)
    } else {
      api.reload('b952b2ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b952b2ac&scoped=true&", function () {
      api.rerender('b952b2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/shopSetting/index.vue"
export default component.exports